import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PACKAGE_ACTIONS, usePackage, usePackageDispatch } from 'contexts/PackageContext';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import Axios from 'axios';
import { Tooltip } from 'antd';


const IconWrapper = styled.div`
    cursor: pointer;
`

const FavouritesIcon = ({
    modelIDs,
    inShortlistSection,
    tooltipPlacement = 'bottom'
}) => {
    const { currentPack, packageCode: PackageCode, useShortlist } = usePackage();
    const dispatch = usePackageDispatch();
    const [isLoading, setIsLoading] = useState(false)
    //const [isInShortlist,  setIsFetching] = useState(inShortlistSection)

    // useEffect(() => {
    //     setIsInShortlist(inShortlistSection)
    // }, [inShortlistSection])

    const { modelID: ModelID, packageModelID: PackageModelID } = modelIDs


    const isFav = useMemo(() => {
        const favs = currentPack.Favourites
        return favs.some(fav => fav.ModelId === ModelID)
    }, [currentPack, ModelID])

    if (!useShortlist) return null;

    const add = async () => {
        setIsLoading(true)
        const favouriteData = await Axios.post(`/favourites/add`, {
            ModelID,
            PackageModelID,
            PackageCode
        })
        setIsLoading(false)
        dispatch({ type: PACKAGE_ACTIONS.ADD_SHORTLIST_ITEM, payload: favouriteData })
        //setIsInShortlist(true)
        //reload()
    }

    const remove = async () => {
        setIsLoading(true)
        await Axios.post(`/favourites/remove`, {
            ModelID,
            PackageModelID,
            PackageCode
        })
        setIsLoading(false)
        dispatch({ type: PACKAGE_ACTIONS.REMOVE_SHORTLIST_ITEM, payload: PackageModelID })
        //setIsInShortlist(false)
        //reload()
    }

    if (isFav) {
        if (inShortlistSection) {
            return (
                <Tooltip placement={tooltipPlacement} title="remove from shortlist">
                    <IconWrapper>
                        {isLoading
                            ?
                            <FontAwesomeIcon icon={icon({ name: 'circle-notch', family: 'sharp', style: 'solid' })} spin />
                            :
                            <FontAwesomeIcon style={{marginRight: '.15rem', fontSize: '1.5rem'}} onClick={remove} icon={icon({ name: 'times', family: 'sharp', style: 'light' })} />
                        }
                    </IconWrapper>
                </Tooltip>
            );
        }
        return (
            <Tooltip placement={tooltipPlacement} title="remove from shortlist">
                <IconWrapper>
                    {isLoading
                        ?
                        <FontAwesomeIcon icon={icon({ name: 'circle-notch', family: 'sharp', style: 'solid' })} spin />
                        :
                        <FontAwesomeIcon onClick={remove} icon={icon({ name: 'heart', family: 'sharp', style: 'solid' })} />
                    }
                </IconWrapper>
            </Tooltip>
        );
    }
    return (
        <Tooltip placement={tooltipPlacement} title="add to shortlist">
            <IconWrapper>
                {isLoading
                    ?
                    <FontAwesomeIcon icon={icon({ name: 'circle-notch', family: 'sharp', style: 'solid' })} spin />
                    :
                    <FontAwesomeIcon onClick={add} icon={icon({ name: 'heart-circle-plus', family: 'sharp', style: 'light' })} />
                }
            </IconWrapper>
        </Tooltip>
    );
};

export default FavouritesIcon;
